import React from "react";
import { Link, useMatch } from "react-router-dom";
import { useEffect, useState } from "react";
import henceforthApi from "../utils/henceforthApi";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import Carousel from "react-bootstrap/Carousel";
import placeholder from "../assets/images/profile_placeholder.png"
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import VideoPlayer from "../components/hslVideoPlayer";
import { getUserProfileImage } from "../utils/constant_value";
function Stories({ getStory, userDetailStory }) {
  const match = useMatch("/user/:id/:type");

  //modal
  const [Reply, setReply] = useState(false);
  const handleCloseReply = () => setReply(false);

  const [Views, setViews] = useState(false);
  const handleCloseViews = () => setViews(false);

  //Remove
  const [showRemove, setShowRemove] = useState(false);
  const handleConfirm = (id) => {
    setShowRemove(id);
  }
  const handleRemove = async (id) => {
    try {
      await henceforthApi?.Posts?.delete(id);
      setShowRemove(false);
      userDetailStory();
    } catch (Error) {
    }
    setShowRemove(false)
  };
  //View

  const [getView, setGetView] = useState([]);
  const handleView = async (_id) => {
    setViews(true);
    const viewResponse = await henceforthApi?.Stories?.view(_id);
    setGetView(viewResponse);
  };

  //Replies
  const [getReply, setGetReply] = useState([]);
  const handleReply = async (_id) => {
    setReply(true);
    const ReplyResponse = await henceforthApi?.Stories?.reply(_id);
    setGetReply(ReplyResponse);
  };


  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const [lightboxImages, setLightboxImages] = useState([])
  const initialiseLightBox = (data) => {
    setPhotoIndex(0)
    setIsOpen(true)
    setLightboxImages(data)
  }


  useEffect(() => {
    // getStory();
  }, [match?.params?.id]);
  return (
    <div className="row">
      <div>
        {isOpen && <Lightbox
          mainSrc={`${henceforthApi.API_FILE_ROOT_ORIGINAL}${lightboxImages[photoIndex].media_url}`}
          nextSrc={lightboxImages[(photoIndex + 1) % lightboxImages.length]}
          prevSrc={lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex((photoIndex + lightboxImages.length - 1) % lightboxImages.length)
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % lightboxImages.length)
          }
        />}
      </div>
      {getStory?.data?.length ? getStory?.data?.map((item, index) => (
        <div class="col-md-4" key={index}>
          <div class="card mb-4 box-shadow border-0 shadow h-100">
            <Link to="">
              <div className="explore-img"
              // onClick={() => handleShow(item?._id)}
              >
                <Carousel interval={null}>
                  {item?.post_medias?.length ? 
                    item?.post_medias?.map((res, index) => (
                      <Carousel.Item key={index}>
                        { res?.media_type ? res?.media_type == "VIDEO/MP4" || res?.media_type == "VIDEO" ?  (
                          // <video
                          //   id="videos"
                          //   class="video-bg"
                          //   src={`https://shadowzapp.sgp1.digitaloceanspaces.com/shadowzapp/video/${res?.media_url}`}
                          // autoPlay
                          // />
                          <VideoPlayer src={res?.media_url} />
                        ): (
                          <img
                            className="d-block w-100"
                            src={`${henceforthApi?.API_FILE_ROOT_ORIGINAL}${res?.media_url}`}
                            alt="PostImage"
                            onClick={() => initialiseLightBox(item?.post_medias)}
                            style={{ cursor: "pointer" }}
                          />
                        ) :<img
                        className="d-block w-100"
                        src={placeholder}
                        alt="PostImage"
                        onClick={() => initialiseLightBox(item?.post_medias)}
                        style={{ cursor: "pointer" }}
                      />}
                      </Carousel.Item>
                    )) : <img
                    className="d-block w-100"
                    src={profile_placeholder}
                    alt="PostImage"
                    style={{ cursor: "pointer" }}
                  />}
                </Carousel>
              </div>
            </Link>
            <div class="card-body">

              <div className="username-box my-1 d-flex justify-content-between align-items-center">
                <div className="d-flex gap-1 ProfileImagePRS-box">
                  <img className="ProfileImagePRS" src={getUserProfileImage(item?.profile_pic)} alt="" />
                  {/* <Link
                    to={`/user/${item?.user_id}`}
                    className="Details_of_User"
                  > */}
                  <p className="fw-bolder m-0" style={{ fontSize: "14px" }}>
                    {item?.name}
                  </p>
                  {/* </Link > */}
                </div>
                <div>
                  <label className="PublicPrivate">
                    <i
                      class={item?.is_private == false ?
                        `fas fa-globe-africa` : `fas fa-lock`}
                      style={{ marginRight: "3px" }}
                    ></i>
                    {item?.is_private == false
                      ? "Public"
                      : "Private"}
                  </label>
                </div>
                
              </div>
              <div className="col-12">
                    <div className="text-end">
                        <label className={item.status == "Active" ? "custom-status" : "custom-status-deactivate"}>
                          {item.status}
                        </label>
                      </div>
                    </div>

              <div className="both-added my-3">
                <div className="">
                  <div className="fw-bolder">
                    <h6
                      onClick={() => handleView(item?._id)}
                      style={{
                        cursor: "pointer",
                        fontSize: "14px",
                      }}
                    >
                      {" "}
                      Views:
                      <span
                        style={{
                          fontWeight: "bold",
                          marginLeft: "3px",
                        }}
                      >
                        {item?.views_count}
                      </span>
                    </h6>
                  </div>
                </div>
                <div className="brown-text text-wrap">
                  <div
                    onClick={() => handleReply(item?._id)}
                    style={{ cursor: "pointer" }}
                    className="fw-bolder"
                  >
                    <h6 style={{ fontSize: "14px" }}>
                      {" "}
                      Comments:
                      <span
                        style={{
                          fontWeight: "bold",
                          fontSize: "14px ",
                          marginLeft: "3px",
                        }}
                      >
                        {item?.replies_count}
                      </span>
                    </h6>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div class="d-flex justify-content-between align-items-center">
                    <div class="btn-group">
                      <div className="bown-num ">
                        <p className="m-0">
                          {" "}
                          <small style={{ whiteSpace: "nowrap" }}>
                            {moment(Number(item?.created_at)).format(
                              "DD MMM YYYY, h:mm a"
                            )}
                          </small>{" "}
                        </p>
                      </div>{" "}
                      <div className="bown-num"></div>
                    </div>
                  </div>
                </div>

                {item?.is_expired == true ? (
                  " "
                ) : (
                  <div className="col-md-6">
                    {/* <button
                      onClick={() => handleConfirm(item?._id)}
                      style={{ float: "right" }}
                      className="btn btn-danger"
                    >
                      Remove
                    </button> */}
                      <Link to={`/media/${item._id}/like`}>
                                    <div className="">
                                      <button
                                        onClick={() => handleConfirm(item._id)}
                                        style={{ float: "right" }}
                                        className="btn mt-2 btn-outline-dark"
                                      >
                                        Details
                                      </button>
                                    </div>
                                  </Link>
                  </div>
                )}
                {/* Remove modal */}
                <Modal
                  show={showRemove}
                  onHide={() => setShowRemove(false)}
                  backdrop="static"
                  keyboard={false}
                  centered
                  className="confirm-box-modal"
                  scrollable

                >
                  <Modal.Header>
                    <Modal.Title>
                      Remove
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="my-3 text-center">
                      Do you want to Remove?
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={() => setShowRemove(false)} className="px-6 confirm-btn">
                      No
                    </Button>
                    <Button onClick={() => handleRemove(showRemove)} className="px-6 confirm-btn">
                      Yes
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      )): <div className="text-center">No Stories Found</div>}
      <div>
        <Modal show={Views} onHide={handleCloseViews} centered scrollable>
          <Modal.Header closeButton>
            <Modal.Title>
              <Link
                to=""
                style={{
                  textDecoration: "none",
                  color: "#000000",
                  cursor: "auto",
                }}
              >
                Views on story
              </Link>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {getView?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Views</div> : getView?.views?.map((item, index) => (
              <>
                <div
                  class="tab-pane fade show active "
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div
                    className="modal-wrapper d-flex align-items-center  mx-2"
                    key={index}
                  >
                    <img
                      src={getUserProfileImage(item?.profile_pic)}
                      alt="ProfileImage"
                      class="modal-profile me-2"
                    />
                    <Link
                      to={`/user/${item?.user_id}/1/1?type=posts`}
                      className="Details_of_User"
                    >
                      <p className="mb-0 profile-name">
                        {item?.full_name
                          ? item?.full_name
                          : "No Views"}
                      </p>
                    </Link>
                  </div>
                </div>
                <hr />
              </>
            ))}
          </Modal.Body>
        </Modal>
        {/* Modal for Reply */}
        <Modal show={Reply} onHide={handleCloseReply} centered scrollable>
          <Modal.Header closeButton>
            <Modal.Title>
              <Link
                to=""
                style={{
                  textDecoration: "none",
                  color: "#000000",
                  cursor: "auto",
                }}
              >
                Replies on story
              </Link>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {getReply?.count == 0 ? <div className="fw-bolder d-flex justify-content-center">No Replies</div> : getReply?.replies?.map((item, index) => (
              <>
                <div className="image-name-box d-flex gap-2 align-items-start w-100" key={index}>
                  <div className="image-box">
                    <img
                      src={getUserProfileImage(item?.profile_pic)}
                      alt="ProfileImage"
                      class="modal-profile align-items-start"
                    />
                  </div>

                  <div className="name-box w-100">
                    <div className="d-flex align-items-center justify-content-between align-items-center">
                      <div>
                        <Link
                          to={`/user/${item?.user_id}/1/1?type=posts`}
                          className="Details_of_User"
                        >
                          <p className="mb-0 profile-name">{item?.full_name}</p>
                        </Link>
                      </div>
                      <div className="">
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                        </p>
                      </div>
                    </div>
                    <p
                      className="m-0"
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      {item?.message}
                    </p>
                  </div>
                </div>
                <hr />
              </>
            ))}

          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Stories;
